var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-to-list"},[_c('router-link',{staticClass:"color-icon form-row",attrs:{"to":_vm.linkBackButton}},[_c('i',{staticClass:"fas fa-arrow-left icon-top-header mr-1"}),_c('div',{staticClass:"my-auto arrow-desc"},[_c('p',{staticClass:"mb-0 p-2"},[_vm._v(_vm._s(_vm.$t("topHeader.backToDiariesList")))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }